/**
 * Resolves a PNG image import to a URL string.
 *
 * Next.js transforms PNG imports into objects: { src: string, width, height }
 * tsup (used for the WordPress IIFE bundle) resolves them as plain strings.
 * This helper handles both shapes so image imports work in all environments.
 */
export const resolveImageSrc = (icon: { src: string } | string): string => (typeof icon === 'string' ? icon : icon.src);
